import React from 'react';

function PaymentMethodFooter() {
  return (
    <section className="w-full flex flex-col justify-center items-center ">
      <span className="text-gray-300 text-[10px] font-arial font-extrabold tracking-wider ">
        Esta transacción será procesada de forma segura gracias a la plataforma
        de:
      </span>
      <div className="flex flex-row justify-center items-center space-x-5">
        <img
          className="w-20"
          src="https://instapago.com/wp-content/uploads/logoinstapago.png"
          alt="instpago_logo"
        />
        <img
          className="w-20"
          src="https://banesco-prod-2020.s3.amazonaws.com/wp-content/themes/banescocontigo/assets/images/header/logotype.png"
          alt="banesco_logo"
        />
      </div>
    </section>
  );
}

export default PaymentMethodFooter;
